module.exports = __webpack_public_path__ + "img/itx-file-type-tiff.760ae17c.svg";